<div class="mat-toolbar-height">
    <div class="div-title">
        <mat-icon>bar_chart</mat-icon>
        <span>{{'events.metric_model'|translate}}</span>
    </div>

    <span class="tracker-spacer"></span>

    <lib-button icon='close' color='none' textColor="muted" (click)="close()">
    </lib-button>
</div>

<form class="tracker-form">
    <div class="form-container">
        <div class="form-header">
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{'form.name'|translate}}</mat-label>
                <input type="text" aria-label="text" matInput [(ngModel)]="metric.name" name="name">
            </mat-form-field>

            <div class="btn-add">
                <lib-button [icon]="'add'" [text]="'form.add'| translate" [color]="'primary'" (click)="addPayload()">
                </lib-button>
            </div>
            <div class="btn-add">
                <lib-button [icon]="'widgets'" [text]="'events.example_field'|translate" [color]="'secondary'"
                    [matMenuTriggerFor]="menu">
                </lib-button>

                <mat-menu #menu="matMenu">
                    @for ( t of filteredTemplates; track t.name) {
                    <button mat-menu-item (click)="addTemplatePayload(t.name)">
                        <mat-icon>{{t.icon}}</mat-icon>
                        {{ t.name }}
                    </button>
                    }
                </mat-menu>

            </div>
        </div>

        <fieldset class="metrics">
            <legend class="metric-legend">
                {{"events.metric_model_payload"|translate}}
            </legend>

            @for(payload of metric.payload; track $index; let index = $index){
            <div class="metric-payload">
                <lib-custom-input-editor class="payload-editor" [config]="payload">
                </lib-custom-input-editor>

                <lib-button icon="delete" color="none" textColor="danger" class="delete-btn"
                    (click)="deletePayload(index)">
                </lib-button>
            </div>
            }
        </fieldset>
    </div>

    <mat-dialog-actions class="btn-actions">
        <span class="tracker-spacer"></span>

        <lib-button text="{{'form.close'|translate}}" color="outline" icon="close" (click)="close()">
        </lib-button>

        <lib-button text="{{'form.save'|translate}}" color="primary" icon="save" (click)="saveMetric()">
        </lib-button>
    </mat-dialog-actions>
</form>